import './PencilBanner.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

export default function PencilBanner({warning="error", children, show, timer=null}){
    return(
        <>
            <div className={"pencil-banner " + (show ? "open " : "") + warning}>
                <div className="pencil-banner-content">
                    <FontAwesomeIcon icon={warning? faCircleExclamation : faCircleCheck} />
                    <div>{children}</div>
                </div>
            </div>
        </>
    )
}